(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Makes everything but `keep` unreachable (keyboard and screen readers) while a dialog is open
  var inertPage = function (keep, on) {
    Array.prototype.forEach.call(body.children, function (el) {
      if (keep.indexOf(el) !== -1 || el.tagName === 'SCRIPT') return;
      if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  };

  /* ---------- Arrival: the photo shrinks into its hero tile ---------- */
  var intro = document.querySelector('[data-intro]');
  if (intro) {
    if (root.classList.contains('entered') || reduced) {
      intro.setAttribute('hidden', '');
      root.classList.add('entered');
    } else {
      var clockEl = intro.querySelector('[data-clock]');
      var tick = function () {
        var d = new Date();
        var m = d.getMinutes();
        if (clockEl) clockEl.textContent = d.getHours() + ' h ' + (m < 10 ? '0' : '') + m;
      };
      tick();
      var clockTimer = setInterval(tick, 20000);
      var titleEl = intro.querySelector('.intro__title');
      var hourNow = new Date().getHours();
      if (titleEl && /^bonjour\.?$/i.test(titleEl.textContent.trim()) && (hourNow >= 18 || hourNow < 5)) titleEl.textContent = 'Bonsoir.';

      body.classList.add('is-locked');
      window.scrollTo(0, 0);
      var leaving = false;
      var failsafe = null;

      var finish = function () {
        clearInterval(clockTimer);
        clearTimeout(failsafe);
        intro.setAttribute('hidden', '');
        root.classList.add('entered');
        body.classList.remove('is-locked');
        try { sessionStorage.setItem('murmure-entered', '1'); localStorage.setItem('murmure-entered', String(Date.now())); } catch (e) { /* private mode */ }
      };
      // The veil fades on its own after 8 s: never leave the page locked if the visitor hesitates
      failsafe = setTimeout(function () { if (!leaving) { leaving = true; finish(); } }, 8000);

      var leave = function () {
        if (leaving) return;
        leaving = true;
        intro.classList.add('is-leaving');
        var photo = intro.querySelector('[data-intro-photo]');
        var target = document.querySelector('[data-hero-photo]');
        if (!photo || !target || !photo.animate) { finish(); return; }
        var r = target.getBoundingClientRect();
        var anim = photo.animate([
          { top: '0px', left: '0px', width: window.innerWidth + 'px', height: window.innerHeight + 'px', borderRadius: '0px' },
          { top: r.top + 'px', left: r.left + 'px', width: r.width + 'px', height: r.height + 'px', borderRadius: getComputedStyle(root).getPropertyValue('--radius') || '28px' }
        ], { duration: 800, easing: 'cubic-bezier(.65, 0, .15, 1)', fill: 'forwards' });
        anim.onfinish = finish;
      };

      intro.querySelectorAll('[data-intro-start]').forEach(function (el) { el.addEventListener('click', leave); });
      intro.querySelectorAll('[data-intro-skip]').forEach(function (el) {
        el.addEventListener('click', function () { leaving = true; finish(); });
      });
      intro.addEventListener('wheel', function (e) { if (e.deltaY > 8) leave(); }, { passive: true });
      var touchY = null;
      intro.addEventListener('touchstart', function (e) { touchY = e.touches[0].clientY; }, { passive: true });
      intro.addEventListener('touchmove', function (e) { if (touchY !== null && touchY - e.touches[0].clientY > 24) leave(); }, { passive: true });
      window.addEventListener('keydown', function (e) {
        if (!leaving && e.target === document.body && (e.key === 'Enter' || e.key === 'ArrowDown' || e.key === ' ')) { e.preventDefault(); leave(); }
      });
    }
  }

  /* ---------- Header & menu ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var menu = document.querySelector('[data-menu]');
  var menuOpen = document.querySelector('[data-menu-open]');
  if (menu && menuOpen) {
    var menuClose = menu.querySelector('[data-menu-close]');
    var setMenu = function (open) {
      menu.classList.toggle('is-open', open);
      menuOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.classList.toggle('is-locked', open);
      if (open && menuClose) menuClose.focus();
      if (!open && menuOpen.focus) menuOpen.focus();
    };
    menuOpen.addEventListener('click', function () { setMenu(true); });
    menu.querySelectorAll('[data-menu-close], .menu__link').forEach(function (el) {
      el.addEventListener('click', function () { setMenu(false); });
    });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) setMenu(false); });
  }

  /* ---------- Soft fade-in on scroll (300 ms, nothing else moves) ---------- */
  var items = document.querySelectorAll('.reveal');
  if (items.length && 'IntersectionObserver' in window && !reduced) {
    root.classList.add('reveal-ready');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Cure selection: price, plan, bottles and caption ---------- */
  document.querySelectorAll('[data-buy-form]').forEach(function (form) {
    var planInput = form.querySelector('[data-selling-plan-input]');
    var radios = form.querySelectorAll('.tier__input');
    var layout = form.closest('[data-product-layout]') || document;
    var stage = layout.querySelector('[data-stage]');
    var caption = layout.querySelector('[data-stage-caption]');
    var sizeEl = layout.querySelector('[data-stage-size]');

    function sync() {
      radios.forEach(function (radio) {
        var card = radio.closest('.tier');
        if (card) card.classList.toggle('is-selected', radio.checked);
        if (!radio.checked) return;
        form.querySelectorAll('[data-cta-price]').forEach(function (el) { el.textContent = radio.getAttribute('data-price'); });
        if (planInput) {
          var plan = radio.getAttribute('data-selling-plan');
          planInput.value = plan || '';
          planInput.disabled = !plan;
        }
        if (stage) stage.setAttribute('data-count', radio.getAttribute('data-tier') || '1');
        if (caption) caption.textContent = radio.getAttribute('data-caption') || '';
        if (sizeEl) { var n = parseInt(radio.getAttribute('data-tier'), 10) || 1; sizeEl.textContent = n > 1 ? n + ' \u00d7 500\u00a0ml' : '500\u00a0ml'; }
        form.querySelectorAll('[data-sticky-name]').forEach(function (el) { el.textContent = (radio.getAttribute('data-caption') || '').split(' \u2014 ')[0]; });
      });
    }
    radios.forEach(function (radio) { radio.addEventListener('change', sync); });
    sync();
    var thumbs = layout.querySelectorAll('[data-stage-view]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (stage) stage.setAttribute('data-view', btn.getAttribute('data-stage-view'));
        thumbs.forEach(function (b) { var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      });
    });
  });

  /* ---------- Sticky add-to-cart once the purchase box has scrolled past ---------- */
  var buybox = document.querySelector('[data-buybox]');
  var sticky = document.querySelector('[data-sticky-bar]');
  if (buybox && sticky && 'IntersectionObserver' in window) {
    var past = false;
    var overlapping = 0;
    var update = function () { sticky.classList.toggle('is-visible', past && overlapping === 0); };
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe(buybox);
    var overlap = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { overlapping += entry.isIntersecting ? 1 : -1; });
      overlapping = Math.max(overlapping, 0);
      update();
    });
    document.querySelectorAll('.closing, .footer').forEach(function (el) { overlap.observe(el); });
  }

  /* ---------- Home page, phones: a "choose my cure" bar once the hero button is out of sight and before the offer ---------- */
  var homeBar = document.querySelector('[data-home-bar]');
  var heroActions = document.querySelector('.hero__actions');
  if (homeBar && heroActions) {
    var homeLink = homeBar.querySelector('a');
    var updateHomeBar = function () {
      var h = heroActions.getBoundingClientRect();
      var offer = document.querySelector('[data-buybox]');
      var o = offer ? offer.getBoundingClientRect() : null;
      var show = h.bottom < 0 && (!o || o.top > window.innerHeight * 0.7) && !body.classList.contains('is-locked');
      homeBar.classList.toggle('is-visible', show);
      homeBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (homeLink) homeLink.setAttribute('tabindex', show ? '0' : '-1');
    };
    window.addEventListener('scroll', updateHomeBar, { passive: true });
    window.addEventListener('resize', updateHomeBar);
    updateHomeBar();
  }

  /* ---------- Oral routine self-check (not a diagnosis) ---------- */
  var quiz = document.querySelector('[data-quiz]');
  if (quiz) {
    var quizResult = document.querySelector('[data-quiz-result]');
    var quizList = quizResult.querySelector('[data-quiz-list]');
    var quizAlert = quizResult.querySelector('[data-quiz-alert]');
    var quizCta = quizResult.querySelector('[data-quiz-cta]');
    var quizError = quiz.querySelector('[data-quiz-error]');
    var advice = {};
    try { advice = JSON.parse(document.querySelector('[data-quiz-advice]').textContent); } catch (e) { /* no advice */ }
    quiz.addEventListener('submit', function (e) {
      e.preventDefault();
      var scores = {};
      var flag = false;
      var missing = false;
      quiz.querySelectorAll('[data-q]').forEach(function (q) {
        var checked = q.querySelector('input:checked');
        if (!checked) { missing = true; return; }
        var v = checked.value;
        if (!v) return;
        if (v === 'alert' || v === 'constant' || v === 'reflux2') flag = true;
        var m = v.match(/^([a-z]+?)(\d)?$/);
        if (!m) return;
        scores[m[1]] = (scores[m[1]] || 0) + (m[2] ? parseInt(m[2], 10) : 1);
      });
      if (missing) { quizError.hidden = false; return; }
      quizError.hidden = true;
      var tags = Object.keys(scores).filter(function (t) { return advice[t]; }).sort(function (a, b) { return scores[b] - scores[a]; });
      if (!tags.length && advice.none) tags = ['none'];
      quizList.textContent = '';
      tags.forEach(function (t) {
        var li = document.createElement('li');
        var p = document.createElement('p'); p.textContent = advice[t].t; li.appendChild(p);
        if (advice[t].u) { var a = document.createElement('a'); a.className = 'link'; a.href = advice[t].u; a.textContent = advice[t].l || advice[t].u; li.appendChild(a); }
        quizList.appendChild(li);
      });
      quizAlert.hidden = !flag;
      if (quizCta) quizCta.hidden = flag;
      quiz.hidden = true;
      quizResult.hidden = false;
      quizResult.focus();
      quizResult.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
    quizResult.querySelector('[data-quiz-restart]').addEventListener('click', function () {
      quiz.reset();
      quizResult.hidden = true;
      quiz.hidden = false;
      quiz.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* ---------- Guides, phones: product bar once the reader is into the text, hidden near the end-of-guide module ---------- */
  var articleBar = document.querySelector('[data-article-bar]');
  if (articleBar) {
    var articleLink = articleBar.querySelector('a');
    var endCta = document.querySelector('.article__cta');
    var updateArticleBar = function () {
      var inText = window.scrollY > window.innerHeight * 0.9;
      var nearEnd = endCta && endCta.getBoundingClientRect().top < window.innerHeight;
      var show = inText && !nearEnd && !body.classList.contains('is-locked');
      articleBar.classList.toggle('is-visible', show);
      articleBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (articleLink) articleLink.setAttribute('tabindex', show ? '0' : '-1');
    };
    window.addEventListener('scroll', updateArticleBar, { passive: true });
    window.addEventListener('resize', updateArticleBar);
    updateArticleBar();
  }

  /* ---------- Cart drawer (AJAX add, falls back to the cart page) ---------- */
  var drawer = document.querySelector('[data-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  if (drawer && overlay && window.fetch) {
    var list = drawer.querySelector('[data-drawer-items]');
    var extras = drawer.querySelector('[data-drawer-extras]');
    var totalEl = drawer.querySelector('[data-drawer-total]');
    var upsell = drawer.querySelector('[data-drawer-upsell]');
    var upsellText = drawer.querySelector('[data-drawer-upsell-text]');
    var upgradeBtn = drawer.querySelector('[data-drawer-upgrade]');
    var shipNote = drawer.querySelector('[data-drawer-ship]');
    var foot = drawer.querySelector('[data-drawer-foot]');
    var emptyText = drawer.getAttribute('data-empty') || '';
    var singleId = parseInt(drawer.getAttribute('data-single-id'), 10) || 0;
    var singlePrice = parseInt(drawer.getAttribute('data-single-price'), 10) || 0;
    var duoId = parseInt(drawer.getAttribute('data-duo-id'), 10) || 0;
    var duoPrice = parseInt(drawer.getAttribute('data-duo-price'), 10) || 0;
    var upsellTemplate = drawer.getAttribute('data-upsell-template') || '';
    var upsellTwoTemplate = drawer.getAttribute('data-upsell-two-template') || '';
    var shipFree = drawer.getAttribute('data-ship-free') || '';
    var subId = parseInt(drawer.getAttribute('data-sub-id'), 10) || 0;
    var subPlan = drawer.getAttribute('data-sub-plan') || '';
    var cureIds = (drawer.getAttribute('data-cure-ids') || '').split(',').filter(Boolean).map(function (n) { return parseInt(n, 10); });
    var subCard = drawer.querySelector('[data-drawer-subscribe]');
    var subButton = drawer.querySelector('[data-subscribe]');
    var titleEl = drawer.querySelector('[data-drawer-title]');
    var titleBag = titleEl ? titleEl.textContent : '';
    var titleAdded = drawer.getAttribute('data-title-added') || titleBag;
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    var lastFocus = null;

    var money = function (cents, currency) {
      try { return new Intl.NumberFormat(root.lang || 'fr', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
    };
    var setOpen = function (open) {
      if (open) lastFocus = document.activeElement;
      drawer.classList.toggle('is-open', open);
      overlay.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) drawer.removeAttribute('inert'); else drawer.setAttribute('inert', '');
      inertPage([drawer, overlay], open);
      body.classList.toggle('is-locked', open);
      if (open && closeBtn) closeBtn.focus();
      if (!open && lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* element is gone */ } }
    };
    var render = function (cart) {
      list.innerHTML = '';
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
      document.querySelectorAll('[data-cart-label]').forEach(function (el) { el.setAttribute('aria-label', el.getAttribute('data-cart-label').replace('__COUNT__', cart.item_count)); });
      if (!cart.items.length) {
        var p = document.createElement('p');
        p.className = 'drawer__empty';
        p.textContent = emptyText;
        list.appendChild(p);
        foot.hidden = true;
        if (extras) extras.hidden = true;
        return;
      }
      foot.hidden = false;
      if (extras) extras.hidden = false;
      cart.items.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'drawer-item';
        var img = document.createElement('div');
        img.className = 'drawer-item__img';
        if (item.image) { var i = document.createElement('img'); i.src = item.image; i.alt = ''; img.appendChild(i); }
        var name = document.createElement('div');
        var n = document.createElement('p'); n.className = 'drawer-item__name'; n.textContent = item.product_title;
        name.appendChild(n);
        var meta = [];
        if (item.variant_title && item.variant_title !== 'Default Title') meta.push(item.variant_title);
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) meta.push(item.selling_plan_allocation.selling_plan.name);
        meta.push('× ' + item.quantity);
        var m = document.createElement('p'); m.className = 'drawer-item__meta'; m.textContent = meta.join(' · ');
        name.appendChild(m);
        var price = document.createElement('div'); price.className = 'drawer-item__price'; price.textContent = money(item.final_line_price, cart.currency);
        row.appendChild(img); row.appendChild(name); row.appendChild(price);
        list.appendChild(row);
      });
      totalEl.textContent = money(cart.total_price, cart.currency);
      var isSingle = function (it) { return singleId ? it.variant_id === singleId : /d[ée]couverte/i.test(it.variant_title || ''); };
      var onlySingles = cart.items.every(isSingle);
      var singleQty = cart.items.reduce(function (n, it) { return n + (isSingle(it) ? it.quantity : 0); }, 0);
      if (subCard) {
        var hasSub = cart.items.some(function (it) { return it.variant_id === subId; });
        var hasCure = cart.items.some(function (it) { return cureIds.indexOf(it.variant_id) !== -1; });
        // The monthly plan is offered next to a single bottle only: for a Duo or a Trio it would silently lower the quantity
        subCard.hidden = hasSub || !hasCure || !(onlySingles && singleQty === 1);
      }
      if (shipNote) shipNote.textContent = (!onlySingles && shipFree) ? shipFree : (shipNote.getAttribute('data-default') || '');
      if (upsell) {
        // One single bottle: the Duo costs the price difference more. Two single bottles: the Duo costs less than the pair.
        var oneToDuo = onlySingles && singleQty === 1 && duoId && duoPrice > singlePrice && upsellTemplate;
        var twoToDuo = onlySingles && singleQty === 2 && duoId && duoPrice < singlePrice * 2 && upsellTwoTemplate;
        var canUpgrade = oneToDuo || twoToDuo;
        upsell.hidden = !canUpgrade;
        if (oneToDuo && upsellText) upsellText.textContent = upsellTemplate.replace('__AMOUNT__', money(duoPrice - singlePrice, cart.currency));
        if (twoToDuo && upsellText) upsellText.textContent = upsellTwoTemplate.replace('__AMOUNT__', money(singlePrice * 2 - duoPrice, cart.currency));
        if (upgradeBtn) upgradeBtn.hidden = !canUpgrade;
      }
    };

    // Replace the cure lines by the monthly subscription (one request to add, one to remove the others)
    var subscribe = function (done) {
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var updates = {};
      cureIds.forEach(function (id) { updates[id] = 0; });
      return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: subId, quantity: 1, selling_plan: parseInt(subPlan, 10) }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: updates }) }); })
        .then(function (r) { return r.json(); })
        .then(done);
    };
    if (subButton && subId && subPlan) {
      subButton.addEventListener('click', function () {
        subButton.disabled = true;
        subscribe(function (cart) { render(cart); })
          .catch(function () { window.location.href = '/cart'; })
          .then(function () { subButton.disabled = false; });
      });
    }

    if (upgradeBtn && duoId && singleId) {
      upgradeBtn.addEventListener('click', function () {
        var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
        var updates = {};
        updates[singleId] = 0;
        upgradeBtn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: duoId, quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: updates }) }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) { render(cart); })
          .catch(function () { window.location.href = '/cart'; })
          .then(function () { upgradeBtn.disabled = false; });
      });
    }

    document.querySelectorAll('[data-drawer-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        if (titleEl) titleEl.textContent = titleBag;
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { render(cart); setOpen(true); })
          .catch(function () { window.location.href = el.getAttribute('href') || '/cart'; });
      });
    });
    overlay.addEventListener('click', function () { setOpen(false); });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', function () { setOpen(false); }); });
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false); });

    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        if (submitter && submitter.name === 'return_to') return;      // "Acheter maintenant": native submit, goes to checkout
        e.preventDefault();
        if (form.getAttribute('aria-busy') === 'true') return;         // a second tap must not add a second bottle
        form.setAttribute('aria-busy', 'true');
        var data = new FormData(form);
        data.delete('return_to');
        fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) { if (titleEl) titleEl.textContent = titleAdded; render(cart); setOpen(true); form.removeAttribute('aria-busy'); })
          .catch(function () { form.removeAttribute('aria-busy'); form.submit(); });
      });
    });
  }

  /* ---------- Estimated delivery dates, from business days ---------- */
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    var template = el.getAttribute('data-template');
    if (!min || !max || !template || !window.Intl) return;
    var addBusinessDays = function (from, n) {
      var d = new Date(from.getTime());
      while (n > 0) { d.setDate(d.getDate() + 1); var day = d.getDay(); if (day !== 0 && day !== 6) n--; }
      return d;
    };
    try {
      var fmt = new Intl.DateTimeFormat(root.lang || 'fr', { weekday: 'long', day: 'numeric', month: 'long' });
      var now = new Date();
      el.textContent = template.replace('__FROM__', fmt.format(addBusinessDays(now, min))).replace('__TO__', fmt.format(addBusinessDays(now, max)));
    } catch (e) { /* keep the static text */ }
  });

  /* ---------- Email window: shown once a week, after a delay or on exit intent (desktop) ---------- */
  var popup = document.querySelector('[data-popup]');
  if (popup && typeof popup.showModal === 'function') {
    var KEY = 'murmure-popup';
    var recent = false;
    try { var last = parseInt(localStorage.getItem(KEY), 10); recent = last && Date.now() - last < 7 * 86400000; } catch (e) { /* storage blocked */ }
    var shown = false;
    var openPopup = function (force) {
      if (shown || popup.open) return true;
      if (!force && (body.classList.contains('is-locked') || (drawer && drawer.classList.contains('is-open')))) return false;
      shown = true;
      popup.showModal();
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* storage blocked */ }
      return true;
    };
    popup.querySelectorAll('[data-popup-close]').forEach(function (el) { el.addEventListener('click', function () { popup.close(); }); });
    popup.addEventListener('click', function (e) { if (e.target === popup) popup.close(); });
    if (popup.querySelector('[data-popup-open-now]')) {
      openPopup(true);
    } else if (!recent) {
      var tries = 0;
      var attempt = function () { if (!openPopup(false) && ++tries < 8) setTimeout(attempt, 4000); };
      setTimeout(attempt, (parseInt(popup.getAttribute('data-delay'), 10) || 12) * 1000);
      if (window.matchMedia('(hover: hover)').matches) {
        setTimeout(function () {
          document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) openPopup(false); });
        }, 8000);
      }
    }
  }

  /* ---------- Cart page: upgrade a single bottle to the Duo ---------- */
  document.querySelectorAll('[data-upgrade-page]').forEach(function (btn) {
    var card = btn.closest('[data-upgrade-card]');
    if (!card || !window.fetch) return;
    btn.addEventListener('click', function () {
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var updates = {};
      updates[card.getAttribute('data-single-id')] = 0;
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: parseInt(card.getAttribute('data-duo-id'), 10), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: updates }) }); })
        .then(function () { window.location.reload(); })
        .catch(function () { btn.disabled = false; });
    });
  });

  /* ---------- Cart page: switch the cure lines to the subscription ---------- */
  document.querySelectorAll('[data-subscribe-page]').forEach(function (btn) {
    var card = btn.closest('[data-sub-id]');
    if (!card || !window.fetch) return;
    btn.addEventListener('click', function () {
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var updates = {};
      (card.getAttribute('data-cure-ids') || '').split(',').filter(Boolean).forEach(function (id) { updates[id] = 0; });
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: parseInt(card.getAttribute('data-sub-id'), 10), quantity: 1, selling_plan: parseInt(card.getAttribute('data-sub-plan'), 10) }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: updates }) }); })
        .then(function () { window.location.reload(); })
        .catch(function () { btn.disabled = false; });
    });
  });
})();
